import { Box, Button, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { PATH_AUTH, PATH_ONBOARD } from "../../routes/path";
import ModalContainer from "../ui-elements/modal-container";
import { CloseDrawerIcon } from "../ui-elements/svg-icons";

export const RepsAccountOnboarding = ({
  open,
  handle_modal,
}: {
  open: boolean;
  handle_modal: () => void;
}) => {
  const navigate = useNavigate();
  const handle_verify = () => {
    navigate(PATH_ONBOARD.account)
    handle_modal();
  };
  return (
    <ModalContainer
      size="sm"
      openModal={open}
      handleModal={handle_modal}
      sx={{}}
      fullWidth={false}
    >
      <Box sx={{ background: "#fff", py: 2, px: 4, borderRadius: "16px" }}>
        <Stack direction={"row"} justifyContent={"end"}>
          <Button sx={{ minWidth: 10 }} onClick={handle_modal}>
            <CloseDrawerIcon />
          </Button>
        </Stack>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <img
            src={"/assets/icons/onboarding/caution-icon.png"}
            style={{ width: 48, height: 48, marginTop: 10, marginBottom: 22 }}
          />
          <Typography variant="h5" sx={{ color: "#0A0B0A", fontWeight: 600 }}>
            Complete account setup
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: "#7991A4",
              fontWeight: 500,
              lineHeight: 1.5,
              textAlign: "center",
            }}
          >
            To apply as representative, upload your valid voter's card.
            Verification helps ensure a personalised experience for all users.
          </Typography>
        </Box>
        <Box
          sx={{
            width: "90%",
            display: "flex",
            flexDirection: "column",
            gap: 2,
            my: 3,
            mx: "auto",
          }}
        >
          <Button
            variant="contained"
            color="primary"

            sx={{
              borderRadius: 40,
              boxShadow: "none",
            }}
            onClick={handle_verify}
          >
            verify Account
          </Button>
        </Box>
      </Box>
    </ModalContainer>
  );
};

export const DeleteAccountModal = ({
  open,
  handle_modal,
}: {
  open: boolean;
  handle_modal: () => void;
}) => {
  const navigate = useNavigate();
  const handle_logout = () => {
    handle_modal();
    navigate(PATH_AUTH.signIn);
  };
  return (
    <ModalContainer
      size="xs"
      openModal={open}
      handleModal={handle_modal}
      sx={{}}
      fullWidth={false}
    >
      <Box sx={{ background: "#fff", py: 3, px: 4, borderRadius: "16px" }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Typography
            variant="body1"
            sx={{ color: "#EB5757", fontWeight: 600 }}
          >
            Delete Account and Data
          </Typography>
          <Typography variant="body2" sx={{ color: "#0A0B0A" }}>
            We're sorry to see you go! Deleting your account will permanently
            erase all your data, including petitions, reports, and profile
            information. This action cannot be undone. If you're certain, click
            "Confirm Delete" to proceed.
          </Typography>
        </Box>
        <Box
          sx={{
            width: "90%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-end",
            gap: 2,
            mx: "auto",
          }}
        >
          <Button sx={{ color: "#0A0B0A" }} onClick={handle_modal}>
            cancel
          </Button>
          <Button onClick={handle_logout} sx={{ color: "#EB5757" }}>
            Confirm Delete
          </Button>
        </Box>
      </Box>
    </ModalContainer>
  );
};

export const LogoutModal = ({
  open,
  handle_modal,
}: {
  open: boolean;
  handle_modal: () => void;
}) => {
  const navigate = useNavigate();
  const handle_logout = () => {
    handle_modal();
    navigate(PATH_AUTH.signIn);
  };

  return (
    <ModalContainer
      size="xs"
      openModal={open}
      handleModal={handle_modal}
      sx={{}}
      fullWidth={false}
    >
      <Box sx={{ background: "#fff", py: 3, px: 4, borderRadius: "16px" }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Typography
            variant="body1"
            sx={{ color: "#EB5757", fontWeight: 600 }}
          >
            Caution!
          </Typography>
          <Typography variant="body2" sx={{ color: "#0A0B0A" }}>
            Are you sure you want to log out?
          </Typography>
        </Box>
        <Box
          sx={{
            width: "90%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-end",
            gap: 2,
            mx: "auto",
          }}
        >
          <Button sx={{ color: "#0A0B0A" }} onClick={handle_modal}>
            cancel
          </Button>
          <Button onClick={handle_logout} sx={{ color: "#EB5757" }}>
            Log Out
          </Button>
        </Box>
      </Box>
    </ModalContainer>
  );
};
